import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initialize() {
    this.reloadTrustpilotWidget();
  }

  reloadTrustpilotWidget() {
    if (!window.Trustpilot) return;

    window.Trustpilot.loadFromElement(this.element, true);
  }
}